export default __webpack_public_path__ + "static/media/fallback_web.18e05ac1.png";